import HermesChat from "@/components/HermesChat";
import { Bot } from "lucide-react";

export default function AIPalChat({ palId, palName, palIcon: PalIcon, color, onClose }) {
  return (
    <HermesChat
      contextHint={`[AI Pal: ${palName}]`}
      title={palName}
      icon={PalIcon || Bot}
      color={color}
      accentColor="text-white"
      layout="full"
      placeholder={`Ask ${palName}...`}
      sessionPrefix={`aipal_${palId}`}
      onClose={onClose}
    />
  );
}
